import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Shield, Zap, Phone } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: Clock,
    title: '48 Horas',
    description: 'Certificación en tiempo récord. No pierdas meses esperando una respuesta.'
  }, {
    icon: Shield,
    title: '100% Legal',
    description: 'Cumple todos los requisitos oficiales del Ministerio de Salud.'
  }, {
    icon: Zap,
    title: 'Sin Burocracia',
    description: 'Proceso simplificado. Adiós al papeleo innecesario.'
  }, {
    icon: Phone,
    title: 'Soporte 24/7',
    description: 'Te acompañamos en cada paso vía WhatsApp. Nunca estarás solo.'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-4">
            ¿Por qué elegirnos?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-5">
            Diseñamos la solución que nosotros mismos hubiéramos querido tener.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-6">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 group" data-id="element-7">
              <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#1e3a5f] transition-colors duration-300" data-id="element-8">
                <benefit.icon className="w-7 h-7 text-[#1e3a5f] group-hover:text-white transition-colors duration-300" data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-11">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}